<h1 class="oops">
  {{ 'PAGE_NOT_FOUND.OOPS' | translate }}
</h1>

<p class="description">
  {{ 'PAGE_NOT_FOUND.CANT_FIND_PAGE' | translate }}
</p>

<span
  class="helper-text"
  [innerHTML]="
    'PAGE_NOT_FOUND.NEED_HELP' | translate: { url: supportUrl } | safe: 'html'
  "
>
</span>

<i2g-router-link
  *ngIf="rootRoute"
  class="root-link"
  [route]="rootRoute"
  [alignment]="AlignmentEnum.center"
  [label]="'PAGE_NOT_FOUND.ROOT_LINK' | translate"
>
</i2g-router-link>

<i2g-link
  [href]="invoice2goUrl"
  [icon]="invoice2goLogo"
  [openInNewTab]="true"
  class="invoice2go-logo"
>
</i2g-link>
